import { APIPutRequest } from '@ancon/wildcat-types'

import Request from '../../client/Request'
import endpoints from '../endpoints'
import { APIType } from '../../types'

type IdentityUsersAPI = {
  put: {
    verifyEmail: APIPutRequest<{}, { verificationToken: string }>
  }
}

const identityUsers: IdentityUsersAPI = {
  put: {
    verifyEmail: new Request(endpoints.user.identityUsers.verifyEmail.list, {
      apiType: APIType.User,
    }).put,
  },
}

export default identityUsers
